<template>
  <div class="container">
    <div class="section">
      <img class="header-img" :src="isBView == 'A' ? 'https://s21.lgstatic.com/growth/activity/20220422/1650599744345.png' : 'https://s20.lgstatic.com/growth/activity/20220422/1650599763029.png'" alt="">
      <img class="header-btn" @click="openWeapp(4, '去提问')" src="https://s20.lgstatic.com/growth/activity/20220422/1650599799475.png">
    </div>
    <div class="section" v-for="(bgImg, i) in bgImgList" :key="i">
      <img :src="bgImg">
      <div v-if="i == 0" class="tabs-container">
        <div class="fixed-nav" ref="fixednav">
          <div class="fixed-nav-content">
            <p
              v-for="(item, index) in theme"
              :key="index"
              :class="['tab-title', activeId === index && 'select-tab']"
              @click="changeTab(index, $event)"
            >
              {{ item }}
            </p>
          </div>
        </div>
        <div class="ques-container">
          <img :src="quesImgList[activeId]">
        </div>
        <div :class="['ques-btn', activeId == 2 && 'bottom']" @click="openWeapp(0, '预约直播 寻求答案')">
          <img src="https://s21.lgstatic.com/growth/activity/20220421/1650523282645.png">
        </div>
      </div>
      <div v-if="i == 1" class="sw-container">
        <div class="swiper-container ">
          <div class="swiper-wrapper">
              <div v-for="(swImg, j) in swImgList" :key="j" class="swiper-slide sw-item">
                <img :src="swImg" alt="">
              </div>
          </div>
        </div>
        <div class="sw-btn" @click="openWeapp(1, '想听谁的直播，点这里告诉我')">
          <img src="https://s20.lgstatic.com/growth/activity/20220421/1650521427582.png">
        </div>
      </div>
      <div v-if="i == 2" class="gift-btn"  @click="openWeapp(2, '看直播 薅羊毛')">
        <img src="https://s20.lgstatic.com/growth/activity/20220421/1650521755575.png">
      </div>
      <div v-if="i == 3" class="card-btn"  @click="openWeapp(3, '马上进群')">
        <img src="https://s20.lgstatic.com/growth/activity/20220421/1650522215675.png">
      </div>
      <div v-if="i == 3" class="more-wrap">
        <div class="more-content" @click="openWeapp(4, '直播你想听什么，点此告诉我！')">
          <div class="more-swiper">
            <img v-for="(img, index) in companyImgs"
              :key="index"
              :src="img"
              :class="['company-item', `left${index}`]"
              />
          </div>
          <div class="more-right">
            <div>直播你想听什么，点此告诉我！</div>
            <div class="more-icon"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { getEduAppVersion, isBiggerThanSpecifiedVersion } from '../../../uitl/getVersion';
export default {
  name: "InterPolateH5New",
  props: ['isBView'],
  data() {
    return {
      page_id: 'n1tia',
      bgImgList: [
        "https://s21.lgstatic.com/growth/activity/20220421/1650509717849.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650509731770.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650509739860.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650522692873.png"
      ],
      theme: ['简历问题', '面试问题', '职业迷茫', '职场关系', '行业动态'],
      activeId: 0,
      swImgList: [
        "https://s20.lgstatic.com/growth/activity/20220421/1650512833536.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650512842340.png",
        "https://s20.lgstatic.com/growth/activity/20220421/1650512850091.png",
        "https://s20.lgstatic.com/growth/activity/20220421/1650512857645.png",
        "https://s20.lgstatic.com/growth/activity/20220421/1650512864914.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650512872078.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650512879891.png",
      ],
      quesImgList: [
        "https://s20.lgstatic.com/growth/activity/20220421/1650522970233.png",
        "https://s20.lgstatic.com/growth/activity/20220421/1650523001336.png",
        "https://s20.lgstatic.com/growth/activity/20220421/1650523008230.png",
        "https://s20.lgstatic.com/growth/activity/20220421/1650523017601.png",
        "https://s21.lgstatic.com/growth/activity/20220421/1650523024561.png"
      ],
      companyImgs: [
        "//www.lgstatic.com/thumbnail_160x160/i/image/M00/49/E7/Ciqc1F9QZJSAC0VBAACwLdjC9yo459.png",
        "//www.lgstatic.com/thumbnail_160x160/i/image2/M01/03/84/CgpVE1_ch26AEM8AAAAxNiZmyCE990.png",
        "//www.lgstatic.com/thumbnail_160x160/i/image/M00/67/04/CgpEMlmepHiAJmEXAAArAJs2qv0103.jpg",
        "//www.lgstatic.com/thumbnail_160x160/i/image2/M00/13/95/CgotOVnwNqeAFbmnAABaH5Q_vVE401.png",
      ]
    };
  },
  mounted() {
    this.eduPlatTrack('WebView', {
      page_id: this.page_id
    });
    var swiper = new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      speed: 3000,
      autoplayDisableOnInteraction: false,
      autoplay: 3000,
      slidesPerView: 'auto',
      centeredSlides: true
    });
    this.loop()
  },
  methods: {
    changeTab(id, event) {
      // 如果选择的和当前激活的不同
      if (id !== this.activeId) {
        this.activeId = id;
        // 计算当前按钮的位置，看是否需要移动
        const spanLeft = event.clientX; // 当前点击的元素左边距离
        const divBox = document.querySelector(".select-tab").clientWidth / 2; // 点击的元素一半宽度
        const totalWidths = document.body.clientWidth; // 屏幕总宽度
        const widths = totalWidths / 2; // 一半的屏幕宽度
        const spanRight = totalWidths - spanLeft; // 元素的右边距离
        const scrollBox = document.querySelector(".fixed-nav"); // 获取最外层的元素
        const scrollL = scrollBox.scrollLeft; // 滚动条滚动的距离
        // 当元素左边距离 或者 右边距离小于100时进行滑动
        if (spanRight < 100 || spanLeft < 100) {
          scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox;
        }
      }
    },
    loop() {
      const items = document.getElementsByClassName('company-item');
      const len = items.length;
      for(let i = 0; i < len; i++) {
        if (i != len - 1) {
          items[i].style.transition = 'all linear .5s';
          items[i].style.transform = `translateX(0.413rem)`;
        } else {
          items[i].style.transform = `translateX(-1.254rem)`;
          items[i].style.zIndex = 0
        }
      }
      this.resultList()
    },
    resultList() {
      const recordList = JSON.parse(JSON.stringify(this.companyImgs))
      const last = recordList.pop();
      recordList.unshift(last);
      this.companyImgs = recordList;
      setTimeout(() => {
        this.loop()
      }, 3000)
    },
    openWeapp(type, btnName) {
      this.eduPlatTrack('WebButtonClick', {
        page_id: this.page_id,
        'button_name': btnName
      });
      const path = `/pages/interpolate/index.html?from=${type}&isNew=1`;
      const userName = 'gh_5bc6c955d1db';
      const miniProgramType = this.isAndroid ? 0 : 1;
      const locationPath = encodeURIComponent(path);
      if (this.isEduApp) {
        const version = isBiggerThanSpecifiedVersion(getEduAppVersion(), '2.3.2');
        const bridgeTitle = this.isAndroid ? version ? 'lgedu' : 'lgeduapp' : 'lgedu';
        const bridgeUrl = `${bridgeTitle}://lgedu.com/miniProgram?userName=${userName}&path=${locationPath}&miniProgramType=${miniProgramType}`;
        window.location = bridgeUrl;
      } else if (this.isLgApp) {
        const lgBridgeTitle = this.isAndroid ? 'lgeduapp' : 'lagou';
        const lgPath = this.isAndroid ? path : locationPath;
        const lgBridgeUrl = `${lgBridgeTitle}://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
        window.location = lgBridgeUrl;
        // 兼容非首页安卓打开小程序
        if (this.isAndroid) {
          window.location = `lagouapp://lagou.com/miniProgram?userName=${userName}&path=${lgPath}&miniProgramType=${miniProgramType}`;
        }
      }
    }
  },
};
</script>
<style lang='less' scoped>
.container {
  position: relative;
  width: 100%;
  overflow-y: auto;
}
.section {
  position: relative;
  display: flex;
  width: 100%;
  img {
    width: 100%;
  }
  .header-img {
    height: 1111px;
  }
  .header-btn {
    position: absolute;
    left: 129px;
    bottom: 40px;
    width: 492px;
    height: 84px;
    -webkit-animation-name: scale;
    -webkit-animation-timing-function: ease-in-out;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
  @keyframes scale {
    0% {
        transform: scale(1);
    }
    25% {
        transform: scale(1.15);
    }
    50% {
        transform: scale(1);
    }
    75% {
        transform: scale(1.15);
    }
  }
}
.tabs-container {
  position: absolute;
  left: 0;
  top: 130px;
  width: 100%;
  height: 787px;
  padding: 0 36px;
  box-sizing: border-box;
}
.fixed-nav {
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  margin-top: 36px;
}

.fixed-nav-content {
  display: flex;
}

.tab-title {
  margin-right: 14px;
  flex-shrink: 0;
  width: 179px;
  height: 68px;
  line-height: 68px;
  background-color: #133161;
  color: #7F92E6;
  font-size: 28px;
  border-radius: 34px;
  text-align: center;
  &:first-child {
    margin-left: 24px;
  }
}
.select-tab {
  background-color: #00C590;
  color: #FFFFFF;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 0.01rem;
  opacity: 0;
  display: none;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  background-color: #fff;
  opacity: 0;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  width: 0.01rem;
  border-radius: 0.01rem;
  opacity: 0;
}
.ques-container {
  width: 678px;
  height: 487px;
  padding: 0 28px 0 35px;
  box-sizing: border-box;
  margin-top: 28px;
  img {
    width: 100%;
  }
}
.sw-container {
  position: absolute;
  top: 162px;
  left: 0;
  width: 100%;
  // height: 380px;
  padding: 0 36px 0 44px;
  box-sizing: border-box;
  overflow: hidden;
  .sw-item {
    width: 603px;
    margin-right: 24px;
    img {
      width: 100%;
      height: 380px;
    }
  }
  .sw-btn {
    width: 584px;
    height: 83px;
    margin: 20px auto 0;
    img {
      width: 100%;
    }
  }
}
.gift-btn {
  position: absolute;
  left: 0;
  bottom: 76px;
  width: 100%;
  height: 83px;
  text-align: center;
  img {
    width: 592px;
    height: 83px;
  }
}
.card-btn {
  position: absolute;
  left: 0;
  top: 120px;
  width: 100%;
  height: 83px;
  text-align: center;
  img {
    width: 676px;
    height: 180px;
  }
}
.ques-btn {
  position: absolute;
  left: 0;
  bottom: 32px;
  width: 100%;
  height: 83px;
  text-align: center;
  &.bottom {
    bottom: 16px;
  }
  img {
    width: 592px;
    height: 83px;
  }
}
.more-wrap {
  position: absolute;
  left: 0;
  top: 340px;
  width: 100%;
  height: 92px;
  padding: 0 40px;
  box-sizing: border-box;
  .more-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 92px;
    line-height: 92px;
    background-color: #243FAE;
    font-size: 26px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #fff;
    padding: 0 46px 0 46px;
    box-sizing: border-box;
    border-radius: 8px;
    .more-swiper {
      // position: relative;
      width: 140px;
      display: flex;
      flex-wrap: nowrap;
      transition: all linear .5s;
      .more-swiper-wrapper {
        width: 140px;
        display: flex;
        flex-wrap: nowrap;
      }
      .company-item {
        display: flex;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        transition: all linear .5s;
        &.left0 {
          margin-left: 0;
          z-index: 1;
        }
        &.left1 {
          margin-left: -15px;
          z-index: 2;
        }
        &.left2 {
          margin-left: -15px;
          z-index: 3;
        }
        &.left3 {
          margin-left: -15px;
          z-index: 4;
        }
      }
    }
    .more-right {
      display: flex;
      align-items: center;
      .more-icon {
        width: 24px;
        height: 25px;
        background: url('https://s20.lgstatic.com/growth/activity/20220421/1650523831606.png') no-repeat center;
        background-size: 24px 25px;
        margin-left: 8px;
      }
    }
  }
}
.modal-container {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  .modal {
    position: absolute;
    top: 40%;
    left: 50%;
    width: 600px;
    background-color: #fff;
    border-radius: 8px;
    transform: translate(-50%, -50%);
    padding: 60px;
    box-sizing: border-box;
    .modal-header {
      display: flex;
      width: 180px;
      height: 40px;
      line-height: 40px;
      margin: 0 auto;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
      justify-content: space-between;
      align-items: center;
      .modal-header-img {
        width: 40px;
        height: 40px;
      }
    }
    .modal-desc {
      height: 40px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 40px;
      text-align: center;
      margin-top: 23px;
    }
    .qrCode {
      display: block;
      width: 350px;
      height: 350px;
      margin: 49px auto 0;
    }
    .modal-btn {
      height: 88px;
      line-height: 88px;
      background: #00B38A;
      border-radius: 4px;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      margin-top: 42px;
    }
    .modal-close {
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      bottom: -130px;
      border-radius: 50%;
      z-index: 10000;
      background: url("../assets/img/h5/icon_delect@2x.png") no-repeat center;
      background-size: 100%;
      transform: translateX(-50%);
    }
  }
}
</style>
